export const UPLOAD_FILE = 'files/UPLOAD'
